import { Title, Text, Group, Button, Divider } from '@mantine/core';
import CommentForm from './CommentForm';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { Fragment } from 'react';

// icons
import { IoDocumentTextOutline } from 'react-icons/io5';
import { BsFiletypeDoc } from "react-icons/bs";

const Comments = ({ onCommentPosted }) => {
    const data = useSelector((state) => state.WebsiteLanguage.data.Komentet);
    const path = process.env.REACT_APP_FILESPATH;
    const RaportStatusId = useSelector((state) => state.WebsiteLanguage.data.RaportStatusId);
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const baseUrl = process.env.REACT_APP_BASEURL

    let nameLocale = '';

    if (WebsiteLanguage === 'sq') {
        nameLocale = 'nameSq';
    } else if (WebsiteLanguage === 'en') {
        nameLocale = 'nameEn';
    } else if (WebsiteLanguage === 'sr') {
        nameLocale = 'nameSr';
    } else {
        nameLocale = 'nameSq';
    };

    const handleReport = (comment) => {
        if (comment && comment.raportimetNeProcedureHetimores) {
            const url = `${baseUrl}Reports/GetInvestigationReport?&type=1&raportimiNeHetimId=${comment.raportimetNeProcedureHetimores[0].id}&InvestigationReportTypeId=${comment.raportimetNeProcedureHetimores[0].investigationReportTypeId}`;
            window.location.href = url;
        }
    };

    const handleDownload = (doc) => {
        const fileUrl = `${path}${doc.media?.fileName}${doc.media?.fileEx}`;

        const link = document.createElement('a');
        link.href = fileUrl;
        link.download = doc.media?.name.replace('.', '');
        link.target = '_blank';
        link.click();
    };

    return (
        <div className="comments-section">
            {[1, 2, 15, 3].includes(RaportStatusId) && (
                <div className="form-comment-section">
                    <CommentForm onCommentPosted={onCommentPosted} />
                </div>
            )}
            <div className="comments-header">
                <Title className="comments-title" order={3}>{GeneralTranslations.coments}</Title>
            </div>
            <div className="comments-body">
                {data
                    // Ne rastet raportimetHistoria kur raportimiStatusiId:2 shfaqet kur raportimetNeProcedureHetimores: [] eshte e ndryshme prej null
                    .filter(comment => !(comment.raportimiStatusiId === 2 && comment.raportimetNeProcedureHetimores.length === 0))
                    .map((comment, index) => (
                        <div key={index} className="comment-box">
                            <div className={comment.ngaZyrtari ? 'comment-apk' : 'comment-user'}>
                                <div className="cm-text">
                                    <Group>
                                        <Text className="cm-title" size="sm">
                                            {GeneralTranslations.statusComment}
                                            <br />
                                            {comment.raportimiStatusi?.parent?.parent?.id > 0 && (
                                                <>
                                                    &nbsp;{comment.raportimiStatusi?.parent?.parent?.id != null ? comment.raportimiStatusi.parent.parent[nameLocale] : null}
                                                    <br />
                                                </>
                                            )}
                                            {comment.raportimiStatusi?.parent?.id > 0 && (
                                                <>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;{comment.raportimiStatusi?.parent?.id != null ? comment.raportimiStatusi.parent[nameLocale] : null}
                                                    <br />
                                                </>
                                            )}
                                            {comment.raportimiStatusi?.id > 0 && (
                                                <>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{comment.raportimiStatusi?.id != null ? comment.raportimiStatusi[nameLocale] : null}
                                                </>
                                            )}
                                        </Text>
                                    </Group>
                                    <Text size="xs" className="cm-dimmed" c="dimmed">
                                        {GeneralTranslations.date} {dayjs(comment.created).format('DD/MM/YYYY HH:mm')}
                                    </Text>
                                    <div className="cm-details gap-1 flex flex-col">
                                        <Title className="comments-title" order={6}>{GeneralTranslations.coment}</Title>
                                        <Text pt="sm" className="cm-paragraph" size="sm">
                                            {comment.komenti}
                                        </Text>
                                    </div>

                                    {/* per te gjitha docs */}
                                    {(comment.raportimetMedia && comment.raportimetMedia.length > 0) && (
                                        <Fragment>
                                            {comment.raportimetMedia && comment.raportimetMedia.some(doc => !doc.vendim && doc.publik) && (
                                                <div className='document-list'>
                                                    <ul>
                                                        {comment.raportimetMedia
                                                            .filter(doc => !doc.vendim && doc.publik)
                                                            .map((doc, index) => (
                                                                <button
                                                                    key={index}
                                                                    onClick={() => handleDownload(doc)}
                                                                >
                                                                    <li key={index}>
                                                                        <Group>
                                                                            <div className="doc-contnet">
                                                                                <Group>
                                                                                    <IoDocumentTextOutline size={22} />
                                                                                    <span>
                                                                                        {doc.emertimi}{doc.media.fileEx}
                                                                                    </span>
                                                                                </Group>
                                                                            </div>
                                                                        </Group>
                                                                    </li>
                                                                </button>
                                                            ))}
                                                    </ul>
                                                </div>
                                            )}


                                        </Fragment>
                                    )}

                                    {/* vetem kur jan ne raportim ne procedure */}
                                    {comment.raportimetNeProcedureHetimores && (comment.raportimetNeProcedureHetimores.length > 0 && comment.raportimetNeProcedureHetimores[0].perfunduar) && (
                                        <Fragment>
                                            <Divider className="mt-4" />
                                            <div className="cm-details mt-1 gap-2 flex flex-col items-start">
                                                <Title className="comments-title" order={6}>{GeneralTranslations.investigationDetails}</Title>
                                                {comment.raportimetNeProcedureHetimores && (comment.raportimetNeProcedureHetimores[0].raportiPublik) &&
                                                    <Button
                                                        className="btn-table"
                                                        variant="filled"
                                                        onClick={() => handleReport(comment)}
                                                    >
                                                        {GeneralTranslations.InvestigationReport}
                                                    </Button>
                                                }
                                            </div>
                                            {comment.raportimetNeProcedureHetimores[0].raportimetMedia && comment.raportimetNeProcedureHetimores[0].raportimetMedia.some(doc => doc.vendim && doc.publik) && (
                                                <div className="flex flex-row gap-1 items-center">
                                                    <Fragment>
                                                        <Text className="cm-title label-cm" size="sm">{GeneralTranslations.Decision}</Text>
                                                        <div className='document-vendim-list'>
                                                            {comment.raportimetNeProcedureHetimores[0].raportimetMedia
                                                                .filter(doc => doc.vendim && doc.publik)
                                                                .map((doc, index) => (
                                                                    <button
                                                                        key={index}
                                                                        className='flex flex-row gap-2 p-2 doc-cm'
                                                                        onClick={() => handleDownload(doc)}
                                                                    >

                                                                        <BsFiletypeDoc size={20} />
                                                                        <Text size="xs" className="cm-dimmed doc-dimmed" c="dimmed">
                                                                            {doc.emertimi}
                                                                        </Text>
                                                                    </button>
                                                                ))}
                                                        </div>
                                                    </Fragment>
                                                </div>
                                            )}
                                            {(comment.raportimetNeProcedureHetimores[0].raportimetMedia && comment.raportimetNeProcedureHetimores[0].raportimetMedia.length > 0) && (
                                                <Fragment>
                                                    {comment.raportimetNeProcedureHetimores[0].raportimetMedia && comment.raportimetNeProcedureHetimores[0].raportimetMedia.some(doc => !doc.vendim && doc.publik) && (
                                                        <div className="cm-details mt-1 gap-1 flex flex-col items-start">
                                                            <div className="flex flex-col other-docs-cm">
                                                                <div className="other-docs-title">
                                                                    <Text className="cm-title" size="sm">{GeneralTranslations.OtherDocuments}</Text>
                                                                </div>
                                                                <div className='document-list'>
                                                                    <ul>
                                                                        {comment.raportimetNeProcedureHetimores[0].raportimetMedia
                                                                            .filter(doc => !doc.vendim && doc.publik)
                                                                            .map((doc, index) => (
                                                                                <button
                                                                                    key={index}
                                                                                    onClick={() => handleDownload(doc)}
                                                                                >
                                                                                    <li key={index}>
                                                                                        <Group>
                                                                                            <div className="doc-contnet">
                                                                                                <Group>
                                                                                                    <IoDocumentTextOutline size={22} />
                                                                                                    <span>
                                                                                                        {doc.emertimi}{doc.media.fileEx}
                                                                                                    </span>
                                                                                                </Group>
                                                                                            </div>
                                                                                        </Group>
                                                                                    </li>
                                                                                </button>
                                                                            ))}
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}


                                                </Fragment>
                                            )}
                                        </Fragment>
                                    )}


                                </div>
                            </div>
                        </div>
                    ))}
            </div>

        </div>
    )
}

export default Comments